import { s as Nt, a as xt, g as Dt, b as At } from "../animation-registry-D_nCEJwJ.js";
import { e as Lt } from "../class-map-Di-Oe7s4.js";
import { o as Wt } from "../if-defined-Cd-e8xtV.js";
import { n as E } from "../property-4FoNj0Pi.js";
import { r as F } from "../state-D4BCZ2JK.js";
import { e as A } from "../query-C42EGI_8.js";
import { x as y, c as Ft } from "../lit-element-8JrrHldg.js";
import { n as be } from "../ref-ArR26hg7.js";
import { l as zt } from "../lodash-DXs1LrID.js";
import { s as Tt } from "../scroll-vwdGLq7V.js";
import { w as Y } from "../watch-ChG-_stu.js";
import { I as _e } from "../IdController-Cpj_A6H5.js";
import "./pwc-label.js";
import "./pwc-input-surface.js";
import "./pwc-icon.js";
import { o as ve, b as It, f as Se, s as Pe, c as $e, p as at, t as Oe, d as Ce, a as ke } from "../composed-offset-position.browser.min-CQcKT3MK.js";
import { P as Ee } from "../pwc-element-CZs0VuUW.js";
import { P as xe, N as Bt } from "../p-slot.component-Cn2P7TaX.js";
import { p as n } from "../pwcProperty-CTLG9yrF.js";
import "./pwc-select-tag.js";
import "../cross-De9fASU6.js";
import "../chevron-down-BoZe62Bw.js";
import { P as De } from "../pwc-interactive-element-B6286Ky3.js";
var Ae = Object.defineProperty, We = Object.getOwnPropertyDescriptor, c = (t, e, i, a) => {
  for (var o = a > 1 ? void 0 : a ? We(e, i) : e, u = t.length - 1, d; u >= 0; u--)
    (d = t[u]) && (o = (a ? d(e, i, o) : d(o)) || o);
  return a && o && Ae(e, i, o), o;
}, ze = (t, e, i) => {
  if (!e.has(t))
    throw TypeError("Cannot " + i);
}, K = (t, e, i) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, i);
}, _ = (t, e, i) => (ze(t, e, "access private method"), i), U, ot, I, q, B, V, lt, Mt;
const Rt = "pwc-popup";
let p = class extends Ee {
  constructor() {
    super(...arguments), K(this, U), K(this, I), K(this, B), K(this, lt), this.slotControlled = [];
  }
  async connectedCallback() {
    super.connectedCallback(), await this.updateComplete, _(this, I, q).call(this);
  }
  async disconnectedCallback() {
    await _(this, B, V).call(this), super.disconnectedCallback();
  }
  async updated(t) {
    super.updated(t), t.has("active") && (this.active ? _(this, I, q).call(this) : await _(this, B, V).call(this)), t.has("anchor") && await _(this, U, ot).call(this), this.active && (await this.updateComplete, this.reposition());
  }
  reposition() {
    if (!(!this.active || !this.anchorEl))
      try {
        const t = [
          ve({ mainAxis: this.distance, crossAxis: this.skidding })
        ];
        this.sync ? t.push(
          It({
            apply: ({ rects: e }) => {
              const i = this.sync === "width" || this.sync === "both", a = this.sync === "height" || this.sync === "both";
              this.popup.style.width = i ? `${e.reference.width}px` : "", this.popup.style.height = a ? `${e.reference.height}px` : "";
            }
          })
        ) : (this.popup.style.width = "", this.popup.style.height = ""), this.flip && t.push(
          Se({
            boundary: this.flipBoundary,
            // @ts-expect-error - We're converting a string attribute to an array here
            fallbackPlacements: this.flipFallbackPlacements,
            fallbackStrategy: this.flipFallbackStrategy === "best-fit" ? "bestFit" : "initialPlacement",
            padding: this.flipPadding
          })
        ), this.shift && t.push(
          Pe({
            boundary: this.shiftBoundary,
            padding: this.shiftPadding
          })
        ), this.autoSize ? t.push(
          It({
            boundary: this.autoSizeBoundary,
            padding: this.autoSizePadding,
            apply: ({ availableWidth: e, availableHeight: i }) => {
              this.autoSize === "vertical" || this.autoSize === "both" ? this.style.setProperty(
                "--popup-auto-size-available-height",
                `${i}px`
              ) : this.style.removeProperty("--popup-auto-size-available-height"), this.autoSize === "horizontal" || this.autoSize === "both" ? this.style.setProperty(
                "--popup-auto-size-available-width",
                `${e}px`
              ) : this.style.removeProperty("--popup-auto-size-available-width");
            }
          })
        ) : (this.style.removeProperty("--popup-auto-size-available-width"), this.style.removeProperty("--popup-auto-size-available-height")), this.arrow && t.push(
          $e({
            element: this.arrowEl,
            padding: this.arrowPadding
          })
        ), _(this, lt, Mt).call(this, t);
      } catch (t) {
        this.triggerError(t);
      }
  }
  render() {
    return y`
      <p-slot
        name="anchor"
        .host=${this}
        @p-slotchange=${_(this, U, ot)}
      ></p-slot>
      <div
        class=${Lt({
      PwcPopup: !0,
      "PwcPopup--active": this.active,
      "PwcPopup--fixed": this.strategy === "fixed"
    })}
      >
        <p-slot .host=${this}></p-slot>
        ${this.arrow ? y`<div class="PwcPopup__arrow" role="presentation"></div>` : ""}
      </div>
    `;
  }
};
U = /* @__PURE__ */ new WeakSet();
ot = async function() {
  await _(this, B, V).call(this);
  try {
    if (this.anchor && typeof this.anchor == "string") {
      const t = this.getRootNode();
      this.anchorEl = t.getElementById(this.anchor);
    } else
      this.anchor instanceof Element ? this.anchorEl = this.anchor : this.anchorEl = this.querySelector('[p-slot="anchor"]');
    if (this.anchorEl instanceof xe) {
      const t = Array.from(this.anchorEl.childNodes || []);
      this.anchorEl = t.find(
        (e) => e && e.nodeType !== Bt.comment && e.nodeType !== Bt.text
      );
    }
    if (!this.anchorEl)
      throw new Error(
        "Invalid anchor element: no anchor could be found using the anchor slot or the anchor attribute."
      );
    _(this, I, q).call(this);
  } catch (t) {
    this.triggerError(t);
  }
};
I = /* @__PURE__ */ new WeakSet();
q = function() {
  this.anchorEl && (this.cleanup = ke(this.anchorEl, this.popup, () => {
    this.reposition();
  }));
};
B = /* @__PURE__ */ new WeakSet();
V = async function() {
  return new Promise((t) => {
    this.cleanup ? (this.cleanup(), this.cleanup = void 0, this.removeAttribute("data-current-placement"), this.style.removeProperty("--popup-auto-size-available-width"), this.style.removeProperty("--popup-auto-size-available-height"), requestAnimationFrame(() => t())) : t();
  });
};
lt = /* @__PURE__ */ new WeakSet();
Mt = function(t) {
  if (!this.anchorEl)
    return;
  const e = this.strategy === "absolute" ? (i) => at.getOffsetParent(i, Oe) : at.getOffsetParent;
  try {
    Ce(this.anchorEl, this.popup, {
      placement: this.placement,
      middleware: t,
      strategy: this.strategy,
      platform: {
        ...at,
        getOffsetParent: e
      }
    }).then(({ x: i, y: a, middlewareData: o, placement: u }) => {
      const d = getComputedStyle(this).direction === "rtl", M = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right"
      }[u.split("-")[0]];
      if (this.setAttribute("data-current-placement", u), Object.assign(this.popup.style, {
        left: `${i}px`,
        top: `${a}px`
      }), this.arrow) {
        const P = o.arrow.x, w = o.arrow.y;
        let g = "", $ = "", O = "", b = "";
        if (this.arrowPlacement === "start") {
          const f = typeof P == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          g = typeof w == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "", $ = d ? f : "", b = d ? "" : f;
        } else if (this.arrowPlacement === "end") {
          const f = typeof P == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
          $ = d ? "" : f, b = d ? f : "", O = typeof w == "number" ? `calc(${this.arrowPadding}px - var(--arrow-padding-offset))` : "";
        } else
          this.arrowPlacement === "center" ? (b = typeof P == "number" ? "calc(50% - var(--popup-arrow-size-diagonal))" : "", g = typeof w == "number" ? "calc(50% - var(--popup-arrow-size-diagonal))" : "") : (b = typeof P == "number" ? `${P}px` : "", g = typeof w == "number" ? `${w}px` : "");
        Object.assign(this.arrowEl.style, {
          top: g,
          right: $,
          bottom: O,
          left: b,
          [M]: "calc(var(--popup-arrow-size-diagonal) * -1)"
        });
      }
    });
  } catch (i) {
    this.triggerError(i);
  }
};
p.tagName = Rt;
c([
  A(".PwcPopup")
], p.prototype, "popup", 2);
c([
  A(".PwcPopup__arrow")
], p.prototype, "arrowEl", 2);
c([
  E()
], p.prototype, "anchor", 2);
c([
  n({ type: Boolean, reflect: !0, default: !1 })
], p.prototype, "active", 2);
c([
  n({ type: String, reflect: !0, default: "top" })
], p.prototype, "placement", 2);
c([
  n({ type: String, reflect: !0, default: "absolute" })
], p.prototype, "strategy", 2);
c([
  n({ type: Number, default: 0 })
], p.prototype, "distance", 2);
c([
  n({ type: Number, default: 0 })
], p.prototype, "skidding", 2);
c([
  n({ type: Boolean, default: !1 })
], p.prototype, "arrow", 2);
c([
  n({
    type: String,
    attribute: "arrow-placement",
    default: "anchor"
  })
], p.prototype, "arrowPlacement", 2);
c([
  n({ type: Number, attribute: "arrow-padding", default: 10 })
], p.prototype, "arrowPadding", 2);
c([
  n({ type: Boolean, default: !1 })
], p.prototype, "flip", 2);
c([
  n({
    type: String,
    attribute: "flip-fallback-placements",
    converter: {
      fromAttribute: (t) => t.split(" ").map((e) => e.trim()).filter((e) => e !== ""),
      toAttribute: (t) => t.join(" ")
    },
    default: ""
  })
], p.prototype, "flipFallbackPlacements", 2);
c([
  n({
    type: String,
    attribute: "flip-fallback-strategy",
    default: "best-fit"
  })
], p.prototype, "flipFallbackStrategy", 2);
c([
  E({ type: Object })
], p.prototype, "flipBoundary", 2);
c([
  n({ type: Number, attribute: "flip-padding", default: 0 })
], p.prototype, "flipPadding", 2);
c([
  n({ type: Boolean, default: !1 })
], p.prototype, "shift", 2);
c([
  E({ type: Object })
], p.prototype, "shiftBoundary", 2);
c([
  n({ type: Number, attribute: "shift-padding", default: 0 })
], p.prototype, "shiftPadding", 2);
c([
  E({ type: String, attribute: "auto-size" })
], p.prototype, "autoSize", 2);
c([
  E({ type: String })
], p.prototype, "sync", 2);
c([
  E({ type: Object })
], p.prototype, "autoSizeBoundary", 2);
c([
  n({ type: Number, attribute: "auto-size-padding", default: 0 })
], p.prototype, "autoSizePadding", 2);
p = c([
  Ft(Rt)
], p);
var Ie = Object.defineProperty, Be = Object.getOwnPropertyDescriptor, r = (t, e, i, a) => {
  for (var o = a > 1 ? void 0 : a ? Be(e, i) : e, u = t.length - 1, d; u >= 0; u--)
    (d = t[u]) && (o = (a ? d(e, i, o) : d(o)) || o);
  return a && o && Ie(e, i, o), o;
}, Ne = (t, e, i) => {
  if (!e.has(t))
    throw TypeError("Cannot " + i);
}, h = (t, e, i) => {
  if (e.has(t))
    throw TypeError("Cannot add the same private member more than once");
  e instanceof WeakSet ? e.add(t) : e.set(t, i);
}, s = (t, e, i) => (Ne(t, e, "access private method"), i), nt, Kt, rt, Ut, ht, jt, pt, qt, ct, Vt, vt, Ht, St, Xt, ut, Yt, S, C, dt, Gt, ft, Jt, yt, Qt, mt, Zt, j, wt, gt, te, N, H, bt, ee, m, v, X, Pt, _t, ie, $t, se, D, L, k, W, T, G, J, Ot, Q, Ct, x, z;
const ae = "pwc-select";
let l = class extends De {
  constructor() {
    super(...arguments), h(this, nt), h(this, rt), h(this, ht), h(this, pt), h(this, ct), h(this, vt), h(this, St), h(this, ut), h(this, S), h(this, dt), h(this, ft), h(this, yt), h(this, mt), h(this, j), h(this, gt), h(this, N), h(this, bt), h(this, m), h(this, X), h(this, _t), h(this, $t), h(this, D), h(this, k), h(this, T), h(this, J), h(this, Q), h(this, x), this.slotControlled = ["label"], this.displayLabel = "", this.search = "", this.selectedOptions = [], this.showNoResultsMessage = !1, this.idController = new _e(this, {
      base: "PwcSelect",
      children: ["label", "dropdown"]
    });
  }
  connectedCallback() {
    super.connectedCallback(), this.handleDocumentFocus = s(this, pt, qt).bind(this), this.handleDocumentKeyDown = s(this, ct, Vt).bind(this), this.debouncedSearch = zt.debounce(s(this, _t, ie), 200), this.debouncedScrollToCurrentOption = zt.debounce(
      () => s(this, ut, Yt).call(this),
      300,
      { leading: !0 }
    ), this.open = !1;
  }
  async handleDisabledChange() {
    this.disabled && (this.open = !1, await this.handleOpenChange());
  }
  async handleReadonlyChange() {
    this.readonly && (this.open = !1, await this.handleOpenChange());
  }
  handleValueChange() {
    const t = s(this, m, v).call(this), e = Array.isArray(this.value) ? this.value : [this.value];
    s(this, k, W).call(this, t.filter((i) => e.includes(i.value))), e[0] !== "" && (this.displayInput.style.color = "var(--selected-option-color)");
  }
  async handleOpenChange() {
    if (this.open && !this.disabled && !this.readonly) {
      s(this, D, L).call(this, this.selectedOptions[0] || s(this, X, Pt).call(this)), this.emit("p-show", {}), s(this, nt, Kt).call(this), await xt(this), this.dropdown.hidden = !1, this.popup.active = !0, requestAnimationFrame(() => {
        s(this, D, L).call(this, this.currentOption);
      });
      const { keyframes: t, options: e } = Dt(this, "select.show", {
        dir: "ltr"
      });
      await At(this.popup.popup, t, e), this.currentOption && Tt(this.currentOption, this.dropdown, "vertical", "auto"), this.emit("p-after-show", {});
    } else {
      this.emit("p-hide", {}), s(this, rt, Ut).call(this), await xt(this);
      const { keyframes: t, options: e } = Dt(this, "select.hide", {
        dir: "ltr"
      });
      await At(this.popup.popup, t, e), this.dropdown.hidden = !0, this.popup.active = !1, this.emit("p-after-hide", {});
    }
  }
  clear() {
    s(this, j, wt).call(this);
  }
  render() {
    var kt, Et;
    const {
      name: t,
      label: e,
      description: i,
      placeholder: a,
      searchable: o,
      search: u,
      disabled: d,
      required: M,
      status: P,
      readonly: w,
      multiple: g,
      maxOptionsVisible: $,
      selectedOptions: O,
      value: b,
      open: f,
      focused: oe,
      placement: le,
      hoist: ne,
      displayLabel: re,
      _label: Z,
      idController: {
        id: he,
        child: { label: tt, dropdown: et }
      },
      slotted: pe,
      showNoResultsMessage: ce,
      texts: ue,
      hideDetails: de,
      errorMessages: fe,
      warningMessages: ye,
      successMessages: me
    } = this, we = o && !d && !w && (u.length || O.length);
    let it = a;
    return o && (it = O.length ? "" : a || "Search for an option"), y`
      <div
        class=${Lt({
      PwcSelect: !0,
      "PwcSelect--open": f,
      "PwcSelect--multiple": g,
      "PwcSelect--disabled": d
    })}
        id=${he}
      >
        <pwc-label
          id=${tt}
          class="PwcSelect__label"
          for=${et}
          description=${Wt(i)}
          ?required=${M}
        >
          ${pe.label ? "" : e}
          <p-slot .host=${this} name="label"></p-slot>
          <p-slot
            .host=${this}
            name="description"
            p-slot="description"
          ></p-slot>
        </pwc-label>

        <pwc-popup
          class="PwcSelect__popup"
          placement=${le}
          strategy=${ne ? "fixed" : "absolute"}
          flip
          shift
          sync="width"
          auto-size="vertical"
          auto-size-padding="10"
        >
          <pwc-input-surface
            p-slot="anchor"
            class="PwcSelect__inputSurface"
            ?focused=${oe || f}
            ?readonly=${w}
            ?disabled=${d}
            status=${Wt(P)}
            @keydown=${s(this, ft, Jt)}
            @mousedown=${s(this, dt, Gt)}
          >
            <div class="PwcSelect__selections">
              ${g ? y`
                    <div class="PwcSelect__tags">
                      ${O.map((R, st) => st < $ || $ <= 0 ? y`
                            <pwc-select-tag
                              removable
                              @remove=${(ge) => s(this, bt, ee).call(this, ge, R)}
                            >
                              ${R.getTextLabel()}
                            </pwc-select-tag>
                          ` : st === $ ? y`
                            <pwc-select-tag>
                              +${O.length - st}
                            </pwc-select-tag>
                          ` : null)}
                    </div>
                  ` : ""}
              ${!g || o ? y`
                    <input
                      ${be(this.interactiveElementRef)}
                      style=${this.value ? "color: var(--selected-option-color)" : "color: var(--unselected-option-color)"}
                      class="PwcSelect__input"
                      type=${o ? "text" : "button"}
                      .placeholder=${it}
                      autocomplete="off"
                      spellcheck="false"
                      autocapitalize="off"
                      ?readonly=${w || !o}
                      ?disabled=${d}
                      .value=${o ? u : re || it}
                      aria-controls=${et}
                      aria-expanded=${f ? "true" : "false"}
                      aria-haspopup="true"
                      aria-labelledby=${tt}
                      aria-disabled=${d ? "true" : "false"}
                      aria-describedby=${(Et = (kt = Z == null ? void 0 : Z.idController) == null ? void 0 : kt.child) == null ? void 0 : Et.description}
                      role="combobox"
                      tabindex="0"
                      @input=${(R) => this.debouncedSearch(R)}
                      @blur=${s(this, ht, jt)}
                    />
                  ` : ""}
            </div>

            <input
              name=${t}
              class="PwcSelect__valueInput"
              type="text"
              ?disabled=${d}
              ?required=${M}
              .value=${Array.isArray(b) ? b.join(", ") : b}
              tabindex="-1"
              aria-hidden="true"
            />

            ${we ? y`
                  <button
                    class="PwcSelect__clear"
                    type="button"
                    aria-label="Clear entry"
                    @focus=${s(this, yt, Qt)}
                    @blur=${s(this, mt, Zt)}
                    @click=${s(this, j, wt)}
                  >
                    <div class="PwcSelect__clear__inner">
                      <pwc-icon icon="cross" size="24px"></pwc-icon>
                    </div>
                  </button>
                ` : ""}

            <pwc-icon
              class="PwcSelect__expandIcon"
              icon="chevron-down"
              size="24px"
            ></pwc-icon>
          </pwc-input-surface>

          <div
            id=${et}
            role="listbox"
            aria-expanded=${f ? "true" : "false"}
            aria-multiselectable=${g ? "true" : "false"}
            aria-labelledby=${tt}
            class="PwcSelect__dropdown"
            tabindex="-1"
          >
            <p-slot
              .host=${this}
              @mouseup=${s(this, gt, te)}
              @p-slotconnected=${s(this, N, H)}
              @p-slotchange=${s(this, N, H)}
            ></p-slot>
            ${ce ? y`<div class="PwcSelect__noResults">${ue.noResults}</div>` : ""}
          </div>
        </pwc-popup>
        ${de ? "" : y` <pwc-input-message
              .errorMessages=${fe}
              .warningMessages=${ye}
              .successMessages=${me}
            ></pwc-input-message>`}
      </div>
    `;
  }
};
nt = /* @__PURE__ */ new WeakSet();
Kt = function() {
  document.addEventListener("focusin", this.handleDocumentFocus), document.addEventListener("mousedown", this.handleDocumentFocus), document.addEventListener("keydown", this.handleDocumentKeyDown);
};
rt = /* @__PURE__ */ new WeakSet();
Ut = function() {
  document.removeEventListener("focusin", this.handleDocumentFocus), document.removeEventListener("mousedown", this.handleDocumentFocus), document.removeEventListener("keydown", this.handleDocumentKeyDown);
};
ht = /* @__PURE__ */ new WeakSet();
jt = function() {
  !this.multiple && this.displayLabel && (this.search = this.displayLabel), this.emit("blur", {});
};
pt = /* @__PURE__ */ new WeakSet();
qt = function(t) {
  const e = t.composedPath();
  this && !e.includes(this) && s(this, x, z).call(this);
};
ct = /* @__PURE__ */ new WeakSet();
Vt = function(t) {
  const e = t.target, i = e.closest(".PwcSelect__clear") !== null, a = e.closest("pwc-select-tag") !== null;
  if (i || a)
    return;
  t.key === "Escape" && this.open && (t.preventDefault(), t.stopPropagation(), s(this, x, z).call(this), s(this, S, C).call(this));
  const o = this.searchable && this.search.length;
  (t.key === "Enter" || t.key === " " && !o) && s(this, vt, Ht).call(this, t), ["ArrowUp", "ArrowDown", "Home", "End"].includes(t.key) && s(this, St, Xt).call(this, t);
};
vt = /* @__PURE__ */ new WeakSet();
Ht = function(t) {
  if (t.preventDefault(), t.stopImmediatePropagation(), !this.open) {
    s(this, Q, Ct).call(this);
    return;
  }
  this.currentOption && !this.currentOption.disabled && (this.multiple ? s(this, T, G).call(this, this.currentOption) : s(this, k, W).call(this, this.currentOption), this.updateComplete.then(() => {
    this.emit("input", {}), this.emit("change", {}), this.emit("p-input", {}), this.emit("p-change", {});
  }), this.multiple || (s(this, x, z).call(this), s(this, S, C).call(this)));
};
St = /* @__PURE__ */ new WeakSet();
Xt = function(t) {
  const e = s(this, m, v).call(this), i = e.indexOf(this.currentOption);
  let a = Math.max(0, i);
  t.preventDefault(), !(!this.open && (s(this, Q, Ct).call(this), this.currentOption)) && (t.key === "ArrowDown" ? (a = i + 1, a > e.length - 1 && (a = 0)) : t.key === "ArrowUp" ? (a = i - 1, a < 0 && (a = e.length - 1)) : t.key === "Home" ? a = 0 : t.key === "End" && (a = e.length - 1), s(this, D, L).call(this, e[a]));
};
ut = /* @__PURE__ */ new WeakSet();
Yt = function() {
  Tt(this.currentOption, this.dropdown, "vertical", "auto");
};
S = /* @__PURE__ */ new WeakSet();
C = function() {
  this.displayInput.focus({ preventScroll: !0 });
};
dt = /* @__PURE__ */ new WeakSet();
Gt = function(t) {
  const e = t.composedPath(), a = t.target.closest(".PwcSelect__clear") !== null, o = e.some(
    (u) => u instanceof Element && u.tagName.toLowerCase() === "pwc-select-tag"
  );
  this.disabled || this.readonly || a || o || (t.preventDefault(), s(this, S, C).call(this), this.open = !this.open);
};
ft = /* @__PURE__ */ new WeakSet();
Jt = function(t) {
  t.stopPropagation(), this.handleDocumentKeyDown(t), this.displayInput.style.color = "var(--selected-option-color)";
};
yt = /* @__PURE__ */ new WeakSet();
Qt = function() {
  this.focused = !0, s(this, x, z).call(this);
};
mt = /* @__PURE__ */ new WeakSet();
Zt = function() {
  this.focused = !1, this.multiple || (this.search = this.displayLabel);
};
j = /* @__PURE__ */ new WeakSet();
wt = function(t) {
  const e = !!t;
  t == null || t.stopPropagation(), this.search.length && s(this, $t, se).call(this), this.value.length && (s(this, k, W).call(this, []), this.updateComplete.then(() => {
    this.emit("clear", {}), this.emit("input", {}), this.emit("change", {}), this.emit("p-clear", {}), this.emit("p-input", {}), this.emit("p-change", {});
  })), e && s(this, S, C).call(this), this.displayInput.style.color = "var(--unselected-option-color)";
};
gt = /* @__PURE__ */ new WeakSet();
te = function(t) {
  const i = t.target.closest("pwc-option"), a = this.value;
  i && !i.disabled && (this.multiple ? s(this, T, G).call(this, i) : s(this, k, W).call(this, i), this.updateComplete.then(() => s(this, S, C).call(this)), this.value !== a && this.updateComplete.then(() => {
    this.emit("input", {}), this.emit("change", {}), this.emit("p-input", {}), this.emit("p-change", {});
  }), this.multiple || (s(this, x, z).call(this), s(this, S, C).call(this)));
};
N = /* @__PURE__ */ new WeakSet();
H = async function() {
  const t = s(this, m, v).call(this), e = Array.isArray(this.value) ? this.value : [this.value], i = [];
  customElements.get("pwc-option") ? (t.forEach((a) => i.push(a.value)), s(this, k, W).call(this, t.filter((a) => e.includes(a.value)))) : (await customElements.whenDefined("pwc-option"), await s(this, N, H).call(this));
};
bt = /* @__PURE__ */ new WeakSet();
ee = function(t, e) {
  t.stopPropagation(), !(this.disabled || this.readonly) && (s(this, T, G).call(this, e, !1), this.updateComplete.then(() => {
    this.emit("input", {}), this.emit("change", {}), this.emit("p-input", {}), this.emit("p-change", {});
  }));
};
m = /* @__PURE__ */ new WeakSet();
v = function(t = !0) {
  return Array.from(this.querySelectorAll("pwc-option")).filter(
    (e) => !t || !e.hidden
  );
};
X = /* @__PURE__ */ new WeakSet();
Pt = function() {
  return this.querySelector('pwc-option[aria-hidden="false"]');
};
_t = /* @__PURE__ */ new WeakSet();
ie = async function(t) {
  const e = t.target, { value: i } = e;
  this.search = i;
  const a = new RegExp(i, "i"), o = s(this, m, v).call(this, !1);
  o.forEach((u) => {
    const d = u.getTextLabel();
    u.hidden = !a.test(d);
  }), this.showNoResultsMessage = !o.find((u) => !u.hidden), await this.updateComplete, s(this, D, L).call(this, this.selectedOptions[0] || s(this, X, Pt).call(this)), this.open = !0;
};
$t = /* @__PURE__ */ new WeakSet();
se = function() {
  this.search = "", s(this, m, v).call(this, !1).forEach((e) => e.hidden = !1), this.showNoResultsMessage = !1;
};
D = /* @__PURE__ */ new WeakSet();
L = function(t = null) {
  s(this, m, v).call(this, !1).forEach((i) => {
    i.current = !1, i.tabIndex = -1;
  }), t && (this.currentOption = t, t.current = !0, t.tabIndex = 0, this.searchable ? this.debouncedScrollToCurrentOption() : t.focus());
};
k = /* @__PURE__ */ new WeakSet();
W = function(t) {
  const e = s(this, m, v).call(this, !1), i = Array.isArray(t) ? t : [t];
  e.forEach((a) => a.selected = !1), i.length && i.forEach((a) => a.selected = !0), s(this, J, Ot).call(this);
};
T = /* @__PURE__ */ new WeakSet();
G = function(t, e) {
  e === !0 || e === !1 ? t.selected = e : t.selected = !t.selected, s(this, J, Ot).call(this);
};
J = /* @__PURE__ */ new WeakSet();
Ot = function() {
  var t, e;
  this.selectedOptions = s(this, m, v).call(this).filter((i) => i.selected), this.multiple ? (this.value = this.selectedOptions.map((i) => i.value), this.displayLabel = "") : (this.value = ((t = this.selectedOptions[0]) == null ? void 0 : t.value) ?? "", this.displayLabel = ((e = this.selectedOptions[0]) == null ? void 0 : e.getTextLabel()) ?? "", this.search = this.displayLabel);
};
Q = /* @__PURE__ */ new WeakSet();
Ct = function() {
  if (this.open || this.disabled || this.readonly) {
    this.open = !1;
    return;
  }
  this.open = !0;
};
x = /* @__PURE__ */ new WeakSet();
z = function() {
  this.open = !1;
};
l.tagName = ae;
r([
  A(".PwcSelect__popup")
], l.prototype, "popup", 2);
r([
  A(".PwcSelect__label")
], l.prototype, "_label", 2);
r([
  A(".PwcSelect__input")
], l.prototype, "displayInput", 2);
r([
  A(".PwcSelect__dropdown")
], l.prototype, "dropdown", 2);
r([
  F()
], l.prototype, "displayLabel", 2);
r([
  F()
], l.prototype, "search", 2);
r([
  F()
], l.prototype, "currentOption", 2);
r([
  F()
], l.prototype, "selectedOptions", 2);
r([
  F()
], l.prototype, "showNoResultsMessage", 2);
r([
  n({ type: String, default: "" })
], l.prototype, "name", 2);
r([
  n({
    converter: {
      fromAttribute: (t) => t.split(" "),
      toAttribute: (t) => t.join(" ")
    },
    default: ""
  })
], l.prototype, "value", 2);
r([
  n({ type: String, default: "Select one..." })
], l.prototype, "placeholder", 2);
r([
  n({ type: Boolean, reflect: !0, default: !1 })
], l.prototype, "searchable", 2);
r([
  n({ type: Boolean, reflect: !0, default: !1 })
], l.prototype, "multiple", 2);
r([
  n({ type: Number, attribute: "max-options-visible", default: 3 })
], l.prototype, "maxOptionsVisible", 2);
r([
  n({ type: Boolean, reflect: !0, default: !1 })
], l.prototype, "disabled", 2);
r([
  n({ type: Boolean, reflect: !0, default: !1 })
], l.prototype, "open", 2);
r([
  n({ type: Boolean, default: !1 })
], l.prototype, "hoist", 2);
r([
  n({ type: String, default: "" })
], l.prototype, "label", 2);
r([
  E({ type: String })
], l.prototype, "description", 2);
r([
  n({ type: String, reflect: !0, default: "bottom" })
], l.prototype, "placement", 2);
r([
  n({ type: Boolean, reflect: !0, default: !1 })
], l.prototype, "required", 2);
r([
  n({
    type: Object,
    default: { noResults: "No matching items on this list" }
  })
], l.prototype, "texts", 2);
r([
  Y("disabled", { waitUntilFirstUpdate: !0 })
], l.prototype, "handleDisabledChange", 1);
r([
  Y("readonly", { waitUntilFirstUpdate: !0 })
], l.prototype, "handleReadonlyChange", 1);
r([
  Y("value", { waitUntilFirstUpdate: !0 })
], l.prototype, "handleValueChange", 1);
r([
  Y("open", { waitUntilFirstUpdate: !0 })
], l.prototype, "handleOpenChange", 1);
l = r([
  Ft(ae)
], l);
Nt("select.show", {
  keyframes: [
    { opacity: 0, scale: 0.9 },
    { opacity: 1, scale: 1 }
  ],
  options: { duration: 100, easing: "ease" }
});
Nt("select.hide", {
  keyframes: [
    { opacity: 1, scale: 1 },
    { opacity: 0, scale: 0.9 }
  ],
  options: { duration: 100, easing: "ease" }
});
export {
  l as PwcSelect
};
